// extracted by mini-css-extract-plugin
export default {"list":"styles_list__7rCXz","item":"styles_item__adyUp","title":"styles_title__hgxdU","cards":"styles_cards__f9V3T","card":"styles_card__UvCse","desc":"styles_desc__Up+vU"};